import { BackAction, NextAction, SubmitAction } from "../components";
import { QuestionnaireActionsRoot } from "./QuestionnaireActionsRoot";

/**
 * Compound component for questionnaire actions.
 *
 * Usage:
 * <QuestionnaireActions>
 *   <QuestionnaireActions.Back category="step-1" />
 *   <QuestionnaireActions.Next />
 * </QuestionnaireActions>
 *
 * Individual actions can also be used directly if you don't need the wrapper:
 * <BackAction category="step-1" />
 * <NextAction />
 *
 * Note: NextAction automatically derives the category from the current section,
 * while BackAction still requires an explicit category prop.
 */
export const QuestionnaireActions = Object.assign(QuestionnaireActionsRoot, {
  Back: BackAction,
  Next: NextAction,
  Submit: SubmitAction,
});

export type { QuestionnaireActionsRootProps as QuestionnaireActionsProps } from "./QuestionnaireActionsRoot";
